import styled, { keyframes } from 'styled-components';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import { timingFunctions } from 'polished';

const getDialogContentWidth = (overlaysize?: string) => {
  if (overlaysize === 'xlarge') {
    return '100%';
  } else if (overlaysize === 'large') {
    return '75%';
  } else if (overlaysize === 'medium') {
    return '700px';
  } else if (overlaysize === 'small') {
    return '450px';
  } else {
    return '570px';
  }
};

const appearIn = keyframes`
	from {
		opacity: 0;
	}
`;

export const Overlay = styled(DialogOverlay)`
  &,
  &[data-reach-dialog-overlay] {
    background: rgba(35, 35, 35, 0.35);
    animation: ${appearIn} 666ms ${timingFunctions('easeOutExpo')};
    z-index: 100;
  }
`;

const slideIn = keyframes`
	from {
		transform: translateY(-100%);
	}
`;

export const Content = styled(DialogContent)<{
  overlaysize?: string;
  width?: string;
}>`
  &,
  &[data-reach-dialog-content] {
    width: ${props => props.width ?? getDialogContentWidth(props.overlaysize)};
    max-width: 80%;
    padding: 0;
    margin: 40px auto 0;
    background: #fff;
    animation: ${slideIn} 666ms ${timingFunctions('easeOutExpo')};
    border-radius: 5px;
  }
`;
